module.exports = __webpack_public_path__ + "img/tron (42).bd0838d4.jpg";